import actions from '../actionTypes';

const initialState = {
  printersList: [],
  userList: [],
  patternDesignUsername: '',
  dreamstimeUserInfo: '',
  adobeStockUserInfo: '',
  vecteezyLoginWindowIsOpen: false,
  patternDesignLoginwindowIsOpen: false,
  dreamstimeLoginWindowIsOpen: false,
  loginError: '',
  registerError: [],
  handleRegisterWindowPattern: false,
  handleRegisterWindowDreamstime: false,
  addPrinterWindowIsOpen: false,
  errorOnAddingPrinter: '',
  showFlashMessage: null
};

export default function vanillaDesignReducer(state = initialState, action) {
  switch (action.type) {
    case actions.PRINTERS_LIST:
      return {
        ...state,
        printersList: action.payload.list
      };
    case actions.USER_LIST:
      return {
        ...state,
        userList: action.payload.list
      };
    case actions.VECTEEZY_LOGIN_WINDOW:
      return {
        ...state,
        vecteezyLoginWindowIsOpen: action.payload.value
      };
    case actions.PATTERN_DESIGN_LOGIN_WINDOW:
      return {
        ...state,
        patternDesignLoginwindowIsOpen: action.payload.value
      };
    case actions.DREAMSTIME_LOGIN_WINDOW:
      return {
        ...state,
        dreamstimeLoginWindowIsOpen: action.payload.value
      };
    case actions.PREMIUM_CONTENT_LOGIN_FAILED:
      return {
        ...state,
        loginError: action.payload.value
      };
    case actions.PATTERN_DESIGN_LOGIN_SUCCESS:
      return {
        ...state,
        patternDesignUsername: action.payload.data
      };

    case actions.REGISTER_ACCOUNT_FAILED:
      return {
        ...state,
        registerError: action.payload.value
      };
    case actions.REGISTER_WINDOW_DREAMSTIME:
      return {
        ...state,
        handleRegisterWindowDreamstime: action.payload.value
      };
    case actions.REGISTER_WINDOW_PATTERN:
      return {
        ...state,
        handleRegisterWindowPattern: action.payload.value
      };
    case actions.SHOW_OR_HIDE_PRINTER_DETAILS_DIALOG:
      return {
        ...state,
        addPrinterWindowIsOpen: action.payload.value,
        errorOnAddingPrinter: ''
      };
    case actions.FAIL_TO_ADD_PRINTER:
      return {
        ...state,
        errorOnAddingPrinter: action.payload
      };

    case actions.DREAMSTIME_USER_INFO:
      return {
        ...state,
        dreamstimeUserInfo: action.payload.dreamstimeUserInfo
      };
    case actions.FLASH_MESSAGE:
      return {
        ...state,
        showFlashMessage: action.payload
      };
    case actions.ADOBE_STOCK_USER_INFO:
      return {
        ...state,
        adobeStockUserInfo: action.payload.adobeStockUserInfo
      };
    default:
      return state;
  }
}
